import { getAttributeFromCondition } from "@evergis/react";

import { DateFilterState } from "../../../ducks/dateFilter/dateFilter";

export const formatDateFilter = (dateFilterConditions: DateFilterState["conditions"]) => {
  if (!dateFilterConditions) return {};

  return Object.keys(dateFilterConditions).reduce((conditions, layerName) => {
    const attributeName = getAttributeFromCondition(dateFilterConditions[layerName]);

    if (!attributeName) return conditions;

    const values = dateFilterConditions[layerName].split(" && ").map(part => part.split(" ")[2]);
    const [min, max] = values;

    return {
      ...conditions,
      [attributeName]: { value: [min, max].join(" - "), min, max },
    };
  }, {});
};
